module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard w-100 d-block",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.name))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "pull-right mr-auto"
  }, [_c('b-nav-form', [(_vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "disabled": true,
      "size": "sm",
      "variant": "warning",
      "id": "addButtonLoaderpro"
    },
    on: {
      "click": _vm.proceedToManualInv
    }
  }, [_vm._v("New Billing")]) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('Filter-Agency-Modal') : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('FilterCBModal') : _vm._e(), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard'), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.goRolloverCont
    }
  }, [_vm._v("Rollover Container")]), _vm._v(" "), (
    (_vm.$sessionsStorage.get('designation') == 'Admin' ||
      _vm.BillingShowList.length > 0) &&
    _vm.isEconomicYear &&
    _vm.$route.path == '/viewBillingDetails/viewBillingDetails'
  ) ? _c('b-button', {
    staticClass: "text-left",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": 'info'
    },
    on: {
      "click": function($event) {
        _vm.ActiveAccordion(_vm.BillingActiveStatus)
      }
    }
  }, [_vm._v("Show Billing Date")]) : _vm._e(), _vm._v(" "), (_vm.consoBooking.length > 0) ? _c('ExcelExportButton', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "service-method": "getAllBilllingJobDash",
      "export-data": _vm.getExportPayload(),
      "filename": 'get-Billing-Job-panel-report.xlsx',
      "button-text": "Export As Excel",
      "exporting-text": "Downloading Please Wait...",
      "size": "sm",
      "variant": "warning",
      "button-class": "pull-right mb-1"
    },
    on: {
      "export-success": _vm.onExportSuccess,
      "export-error": _vm.onExportError
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-success"
    },
    on: {
      "click": function($event) {
        _vm.showInvoiceGraph = true
      }
    }
  }, [_vm._v("📊 Invoice Graph")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-card', [(
    (_vm.$sessionsStorage.get('designation') == 'Admin' ||
      _vm.BillingShowList.length > 0) &&
    _vm.isEconomicYear &&
    _vm.BillingActiveStatus
  ) ? _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Billing Start Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "date",
      "placeholder": "Enter Billing Start Date",
      "min": _vm.calculateMinDate(),
      "max": _vm.calculateMaxDate()
    },
    model: {
      value: (_vm.configration.config_bill_start_date),
      callback: function($$v) {
        _vm.$set(_vm.configration, "config_bill_start_date", $$v)
      },
      expression: "configration.config_bill_start_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Billing End Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "date",
      "placeholder": "Enter Billing End Date",
      "min": _vm.calculateMinDate(),
      "max": _vm.calculateMaxDate()
    },
    model: {
      value: (_vm.configration.config_bill_end_date),
      callback: function($$v) {
        _vm.$set(_vm.configration, "config_bill_end_date", $$v)
      },
      expression: "configration.config_bill_end_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Enter Billing Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "date",
      "placeholder": "Enter Billing Date",
      "min": _vm.calculateMinDate(),
      "max": _vm.calculateMaxDate()
    },
    model: {
      value: (_vm.configration.config_billing_date),
      callback: function($$v) {
        _vm.$set(_vm.configration, "config_billing_date", $$v)
      },
      expression: "configration.config_billing_date"
    }
  })], 1), _vm._v(" "), (_vm.$sessionsStorage.get('designation') == 'Admin') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Allowed Users")]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.$store.getters['common/getAllUserList'],
      "selected-options": _vm.user_items,
      "placeholder": "Select User",
      "multiple": true,
      "id": "User"
    },
    on: {
      "select": _vm.SelectMultiUser
    },
    model: {
      value: (_vm.configration.multiple_user_id),
      callback: function($$v) {
        _vm.$set(_vm.configration, "multiple_user_id", $$v)
      },
      expression: "configration.multiple_user_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    staticClass: "ml-2 mb-2 mt-4",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.updateConfig()
      }
    }
  }, [_vm._v("\n              Save")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Date Filter Type")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.dateFilterTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Date Type"
    },
    model: {
      value: (_vm.dateFilterType),
      callback: function($$v) {
        _vm.dateFilterType = $$v
      },
      expression: "dateFilterType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date Range")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Invoice Number"
    },
    model: {
      value: (_vm.InvoiceNoFilter),
      callback: function($$v) {
        _vm.InvoiceNoFilter = $$v
      },
      expression: "InvoiceNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Vessel"
    },
    model: {
      value: (_vm.vessleFilter),
      callback: function($$v) {
        _vm.vessleFilter = $$v
      },
      expression: "vessleFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Shipping Bill Number"
    },
    model: {
      value: (_vm.SBFilter),
      callback: function($$v) {
        _vm.SBFilter = $$v
      },
      expression: "SBFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataPOR,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      }
    },
    model: {
      value: (_vm.PORfilter),
      callback: function($$v) {
        _vm.PORfilter = $$v
      },
      expression: "PORfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.finalAllPlaceDataPOD,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.PODfilter),
      callback: function($$v) {
        _vm.PODfilter = $$v
      },
      expression: "PODfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.containerTypeList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.containerTypeFilter),
      callback: function($$v) {
        _vm.containerTypeFilter = $$v
      },
      expression: "containerTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.shippingLineList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.shippingLineFilter),
      callback: function($$v) {
        _vm.shippingLineFilter = $$v
      },
      expression: "shippingLineFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Container  No."
    },
    model: {
      value: (_vm.ContainerFilter),
      callback: function($$v) {
        _vm.ContainerFilter = $$v
      },
      expression: "ContainerFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Shipper Inv No."
    },
    model: {
      value: (_vm.shiperInvFilter),
      callback: function($$v) {
        _vm.shiperInvFilter = $$v
      },
      expression: "shiperInvFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Assignment No."
    },
    model: {
      value: (_vm.assignmentFilter),
      callback: function($$v) {
        _vm.assignmentFilter = $$v
      },
      expression: "assignmentFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.jobList,
      "option-value": "jv",
      "option-text": "jt",
      "placeholder": " JobType"
    },
    model: {
      value: (_vm.jobTypeFilter),
      callback: function($$v) {
        _vm.jobTypeFilter = $$v
      },
      expression: "jobTypeFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.branchList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": " Branch"
    },
    model: {
      value: (_vm.branchfilter),
      callback: function($$v) {
        _vm.branchfilter = $$v
      },
      expression: "branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "isDisabled": _vm.$route.path === '/viewBillingDetails/viewBillingDetails' ? false : true,
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.statusFilter),
      callback: function($$v) {
        _vm.statusFilter = $$v
      },
      expression: "statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select SOB Status"
    },
    model: {
      value: (_vm.SOBFilter),
      callback: function($$v) {
        _vm.SOBFilter = $$v
      },
      expression: "SOBFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.BillingStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Billing Status"
    },
    model: {
      value: (_vm.BillingFilter),
      callback: function($$v) {
        _vm.BillingFilter = $$v
      },
      expression: "BillingFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.BillingTypeStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Billing Type Status"
    },
    model: {
      value: (_vm.BillingTypeFilter),
      callback: function($$v) {
        _vm.BillingTypeFilter = $$v
      },
      expression: "BillingTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.SlinePaymentStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Payment Status"
    },
    model: {
      value: (_vm.SlinePaymentFilter),
      callback: function($$v) {
        _vm.SlinePaymentFilter = $$v
      },
      expression: "SlinePaymentFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Overseas Number"
    },
    model: {
      value: (_vm.cnDNNoFilter),
      callback: function($$v) {
        _vm.cnDNNoFilter = $$v
      },
      expression: "cnDNNoFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mt-3"
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "id": "checkbox-group-1",
      "options": _vm.jobRecList,
      "name": "flavour-1"
    },
    model: {
      value: (_vm.jobRecFilter),
      callback: function($$v) {
        _vm.jobRecFilter = $$v
      },
      expression: "jobRecFilter"
    }
  })], 1)], 1), _vm._v(" "), (_vm.AllResubmissionJOBNO && _vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "marquee-container"
  }, [_c('div', {
    ref: "marquee",
    staticClass: "marquee"
  }, [_c('b-badge', {
    staticClass: "custom-badge",
    attrs: {
      "variant": "danger"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.AllResubmissionJOBNO))])])], 1)])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "center": ""
    }
  }, [_c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2 mb-2",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2 mb-2",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('BILLING_SCREEN', 'Export As Excel')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2 mb-2",
    attrs: {
      "disabled": _vm.ExcelExecutionBtnName != 'Export All Execution' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('BILLING_SCREEN_ALL', 'Export All Execution')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ExcelExecutionBtnName) + "\n              "), (_vm.ExcelExecutionBtnName != 'Export All Execution') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('b-button', {
    staticClass: "ml-2 mb-2",
    attrs: {
      "disabled": _vm.ExcelMultiBillBtnName != 'Export All Multi Bill' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('MultiBILLING_SCREEN', 'Export All Multi Bill')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ExcelMultiBillBtnName) + "\n              "), (_vm.ExcelMultiBillBtnName != 'Export All Multi Bill') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBSJBtnName != 'FF EXP OF REPORT' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getBuyingSellingJobsList('Excell')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ExcelBSJBtnName) + "\n              "), (_vm.ExcelBSJBtnName != 'FF EXP OF REPORT') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('b-button', {
    staticClass: "ml-2 mb-2",
    attrs: {
      "size": "sm",
      "text": "View Mult-Billing",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.viewAllMultiBillingDetails()
      }
    }
  }, [_vm._v("View All Mult-Billing")]) : _vm._e(), _vm._v(" "), (_vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('b-button', {
    staticClass: "ml-2 mb-2",
    attrs: {
      "size": "sm",
      "text": "Lock & Un-Lock Panel",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.viewAllUnlockDetails()
      }
    }
  }, [_vm._v("Lock & Un-Lock Panel")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "invoice-graph-modal",
      "size": "xl",
      "title": "📊 Billing Invoice Graph",
      "hide-footer": "",
      "centered": ""
    },
    model: {
      value: (_vm.showInvoiceGraph),
      callback: function($$v) {
        _vm.showInvoiceGraph = $$v
      },
      expression: "showInvoiceGraph"
    }
  }, [(!_vm.invoiceChartData) ? _c('div', {
    staticClass: "text-center p-4 text-muted"
  }, [_c('h5', [_vm._v("No data available. Please load records first.")])]) : _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "320",
      "options": _vm.invoiceChartData.donut.chartOptions,
      "series": _vm.invoiceChartData.donut.series
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "320",
      "options": _vm.invoiceChartData.bar.chartOptions,
      "series": _vm.invoiceChartData.bar.series
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    staticClass: "text-center text-muted",
    attrs: {
      "md": "12"
    }
  }, [_c('small', [_vm._v("Showing stats for "), _c('strong', [_vm._v(_vm._s(_vm.consoBooking.length))]), _vm._v(" records currently loaded on this page.")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', [_c('b-pagination', {
    staticClass: "mt-3",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), _c('div', [_c('b-row', {
    staticClass: "align-content-end mt-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [(_vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.SelectAll(_vm.consoBooking)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.AllModule_ids.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.AllModule_ids.length > 0 && _vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.ProceedMultiBilling
    }
  }, [_vm._v("Proceed Multi Billing")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "padding": "0px 1rem 0 1rem"
    },
    attrs: {
      "cols": "4"
    }
  }, [(_vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('model-list-select', {
    attrs: {
      "list": _vm.PaginationList,
      "option-value": "pagv",
      "option-text": "pagt",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.pagechangeData()
      }
    },
    model: {
      value: (_vm.PaginationCount),
      callback: function($$v) {
        _vm.PaginationCount = $$v
      },
      expression: "PaginationCount"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.consoBooking,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "jobType",
      fn: function(row0) {
        return [(row0.item.finalBillingCompleted != '1' && _vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.AllModule_ids),
            expression: "AllModule_ids"
          }],
          attrs: {
            "type": "checkbox",
            "id": row0.item.TPTClient
          },
          domProps: {
            "value": row0.item.allModuleId,
            "checked": Array.isArray(_vm.AllModule_ids) ? _vm._i(_vm.AllModule_ids, row0.item.allModuleId) > -1 : (_vm.AllModule_ids)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.AllModule_ids,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = row0.item.allModuleId,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.AllModule_ids = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.AllModule_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.AllModule_ids = $$c
              }
            }, function($event) {
              _vm.updateSelectAll($event, row0.item)
            }]
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row1) {
        return [(row1.item.resubmissionInvStatus) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v(_vm._s(row1.item.resubmissionInvStatus))]), _c('br')]) : _vm._e(), _c('br'), _vm._v(" "), _c('md-icon', [_vm._v(_vm._s(row1.item.shipmentType == "1" ||
          row1.item.shipmentType == "Sea_Shipment" ?
          "directions_boat" :
          "flight_takeoff"))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row1.item.mainSalesSeries))]), _c('br'), _vm._v(" "), (row1.item.CNDNSeries) ? _c('b', [_vm._v(_vm._s("CN/DN : " + row1.item.CNDNSeries))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                " + _vm._s(row1.item.jobType) + " (" + _vm._s(row1.item.shipmentType == "1" ||
          row1.item.shipmentType == "Sea_Shipment" ?
          "Sea" :
          "Air") + "\n                " + _vm._s(row1.item.transportType) + ")")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Dt. : " + _vm._s(_vm._f("moment")(row1.item.assignmentDate)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.raisedFrom)), _c('br')]), _vm._v(" "), _c('span', [_vm._v(" By : " + _vm._s(row1.item.raisedBy))]), _vm._v(" "), _c('br'), _vm._v(" "), (
          row1.item.sob_date_detected != '' &&
          row1.item.sob_date_detected != null
        ) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("SOB : " + _vm._s(row1.item.sob_date_detected))]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("SAILED")])])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/billInvDash',
                query: {
                  assignment: row1.item.mainSalesSeries
                }
              })
            }
          }
        }, [_vm._v("Inv Dashboard")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row1.item.allModuleId,
            "jb_series": row1.item.mainSalesSeries
          }
        }), _vm._v(" "), (row1.item.SplitedStatus != '0') ? _c('Splitmerge-Summary', {
          staticClass: "mt-2",
          attrs: {
            "SM_Status": 1,
            "title": 'Split & Merge Track - ',
            "SM_all_module_id": row1.item.allModuleId,
            "SM_jb_series": row1.item.mainSalesSeries
          }
        }) : _vm._e(), _vm._v(" "), _c('Quotation-Summary', {
          attrs: {
            "QT_fk_all_module_id": row1.item.allModuleId,
            "QT_jb_series": row1.item.mainSalesSeries
          }
        }), _vm._v(" "), (row1.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.allModuleId),
            "JobNo": row1.item.mainSalesSeries
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Lats Updated Dt. : " + _vm._s(row1.item.latestUpdateForBilling))])]
      }
    }, {
      key: "TPTClient",
      fn: function(row11) {
        return [(
          row11.item.clientType == '3' && row11.item.transportType == 'Export'
        ) ? _c('b', [_vm._v("\n                Client Name : " + _vm._s(row11.item.exporter) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType == '3') ? _c('b', [_vm._v("\n                Overseas Agent : " + _vm._s(row11.item.TPTClient) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType != '3') ? _c('b', [_vm._v("\n                " + _vm._s(row11.item.TPTClient) + "\n                "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "ffInvoiceClosed",
      fn: function(row2) {
        return [(row2.item.jobType.split(',').includes('FF')) ? _c('span', [_vm._v("FF :-\n                " + _vm._s(row2.item.ffInvoiceClosed == "1" ? "Received" : "Not-Received")), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.jobType.split(',').includes('CC')) ? _c('span', [_vm._v("CC :-\n                " + _vm._s(row2.item.ccInvoiceClosed == "1" ? "Received" : "Not-Received")), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.jobType.split(',').includes('TPT')) ? _c('span', [_vm._v("TPT :-\n                " + _vm._s(row2.item.tptInvoiceClosed == "1" ? "Received" : "Not-Received"))]) : _vm._e()]
      }
    }, {
      key: "containerNo",
      fn: function(row15) {
        return [_c('b-button', {
          staticClass: "ml-1",
          staticStyle: {
            "font-size": "0.675rem",
            "margin-left": "5px"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.proceedAssignmentProforma(
                row15.item.allModuleId,
                row15.item.isConsolidation,
                row15.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Proceed To Proforma")]), _vm._v(" "), (row15.item.newfreightContainers && row15.item.jobType.indexOf('FF') >= 0) ? _c('BookingTrack', {
          attrs: {
            "containerArr": row15.item.newfreightContainers,
            "slineName": row15.item.shippingLine,
            "clientName": row15.item.TPTClient,
            "modal_title": ("Container Movement Booking No: " + (row15.item.validBookingNo) + " Job No - " + (row15.item.mainSalesSeries) + " Client: " + (row15.item.TPTClient)),
            "JOBNO": row15.item.mainSalesSeries,
            "shipment_id": Number(0),
            "subscription_id": Number(0),
            "fk_sub_track_id": Number(0),
            "fk_all_module_id": Number(row15.item.allModuleId),
            "fk_booking_id": Number(row15.item.fk_booking_id),
            "fk_container_id": Number(0),
            "booking_number": row15.item.validBookingNo,
            "container_number": ''
          }
        }) : _vm._e(), _vm._v(" "), (row15.item.containerNo) ? _c('div', _vm._l((row15.item.containerNo.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                    ")])], 1), _vm._v(" "), (row15.item.allModuleId && item1 && row15.item.jobType.split(',').includes('FF')) ? _c('ContaierWebLogSummary', {
            attrs: {
              "PMC_title": 'Container Event Summary Job No - ' + row15.item.mainSalesSeries,
              "PMC_JOBID": row15.item.allModuleId,
              "PMC_JOBNO": row15.item.mainSalesSeries,
              "PMC_CONTNO": item1.split(' // ')[0],
              "PMC_JOBDATE": '',
              "PMC_JOBTYPE": '',
              "PMC_AgentType": '',
              "PMC_Client": '',
              "PMC_Sline": ''
            }
          }) : _vm._e()], 1)
        })) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "shipperInv",
      fn: function(row150) {
        return [(row150.item.shipperInv) ? _c('div', _vm._l((row150.item.shipperInv.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2) + "\n                    ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "ShippingB",
      fn: function(row100) {
        return [(row100.item.ShippingB) ? _c('div', _vm._l((row100.item.ShippingB.split(',')), function(item3, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item3 == "" ? "-------" : item3) + "\n                    ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "billingSeries",
      fn: function(row1000) {
        return [(_vm.$route.path != '/viewBillingDetails/viewClosedAgentExpensePending') ? _c('b-badge', {
          attrs: {
            "variant": row1000.item.is_expense_status == 'Yes' ? 'success' : 'danger'
          }
        }, [_c('b', [_vm._v("Expense : " + _vm._s(row1000.item.is_expense_status))]), _c('br')]) : (_vm.$route.path == '/viewBillingDetails/viewClosedAgentExpensePending') ? _c('b-badge', {
          attrs: {
            "variant": row1000.item.is_agent_expense_status == 'Yes' ? 'success' : 'danger'
          }
        }, [_c('b', [_vm._v("Expense : " + _vm._s(row1000.item.is_agent_expense_status))]), _c('br')]) : _vm._e(), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1000.item.is_additionalTask_status == 'Yes' ? 'success' : 'danger'
          }
        }, [_c('b', [_vm._v("Additional Task : " + _vm._s(row1000.item.is_additionalTask_status))]), _c('br')]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1000.item.is_manifest_status == 'Yes' ? 'success' : 'danger'
          }
        }, [_c('b', [_vm._v("Manifestation : " + _vm._s(row1000.item.is_manifest_status))]), _c('br')]), _vm._v(" "), (
          row1000.item.jobType.split(',').includes('MISC') ||
          row1000.item.jobType.split(',').includes('YARD') ||
          row1000.item.jobType.split(',').includes('IB')
        ) ? _c('span', [(row1000.item.billingSeries) ? _c('div', _vm._l((row1000.item.billingSeries.split(',')), function(item3, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item3 == "" ? "-------" : item3) + "\n                      ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])]) : _c('span', [(
          (row1000.item.shipmentType == '1' ||
            row1000.item.shipmentType == 'Sea_Shipment') &&
          row1000.item.invoiceNoCreated
        ) ? _c('div', _vm._l((row1000.item.invoiceNoCreated.split(',')), function(item3, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item3 == "" ? "-------" : item3) + "\n                      ")])], 1)])
        })) : (
          (row1000.item.shipmentType != '1' ||
            row1000.item.shipmentType != 'Sea_Shipment') &&
          row1000.item.billingSeries
        ) ? _c('div', _vm._l((row1000.item.billingSeries.split(',')), function(item3, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item3 == "" ? "-------" : item3) + "\n                      ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])])]
      }
    }, {
      key: "Payment_Status",
      fn: function(row16) {
        return [_c('b-badge', {
          attrs: {
            "variant": row16.item.oe_exp_payment_status == 'Yes' ? 'success' : 'danger'
          }
        }, [_c('b', [_vm._v("OE Exp Paid Status : " + _vm._s(row16.item.oe_exp_payment_status))]), _c('br')]), _vm._v(" "), (row16.item.oe_exp_payment_date) ? _c('b', [_vm._v("OE Exp Paid Date : " + _vm._s(row16.item.oe_exp_payment_date))]) : _vm._e(), _c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row16.item.Payment_Status == 'Yes' ? 'success' : 'danger'
          }
        }, [_c('b', [_vm._v(_vm._s(row16.item.Payment_Status))])]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row16.item.billingType == 'Overseas Billing' ? 'success' : 'info'
          }
        }, [_c('b', [_vm._v(_vm._s(row16.item.billingType))])])]
      }
    }, {
      key: "mainEnquiryId",
      fn: function(row15) {
        return [_c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.proceedBilling(
                row15.item.allModuleId,
                row15.item.newContainerFlow,
                row15.item.isConsolidation,
                row15.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v(_vm._s((row15.item.finalBillingCompleted == "1" || row15.item.finalBillingCompleted == "4") ||
          (row15.item.billingType == "Overseas Billing" &&
            row15.item.closedOverseasStatus == "Overseas Closed") ?
          "Show Billing" :
          "Proceed To Billing"))]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((row15.item.CRDRArr), function(cr_item, cr_index) {
          return _c('div', {
            key: cr_index
          }, [(
            row15.item.frghtTermsMbl == 'Collect' &&
            row15.item.frghtTermsHbl == 'Collect'
          ) ? _c('b-badge', {
            staticClass: "p-2",
            attrs: {
              "variant": "warning"
            }
          }, [_c('b', [_vm._v("Credit Note Pending")]), _c('br')]) : _vm._e(), _vm._v(" "), (
            cr_item.uploadCreditDebit != '' && cr_item.approvalStatus == '1'
          ) ? _c('b-badge', {
            staticClass: "p-1",
            attrs: {
              "variant": "warning",
              "size": "sm"
            },
            on: {
              "click": function($event) {
                _vm.PrintNote(row15.item.mainSalesSeries, cr_item.uploadCreditDebit)
              }
            }
          }, [(cr_item.creditDebitNoteType == '1') ? _c('span', [_vm._v(_vm._s(cr_item.noteSeries) + "\n                  ")]) : _c('b', [_vm._v(_vm._s(cr_item.noteSeries))]), _c('br')]) : _vm._e(), _vm._v(" "), (
            row15.item.mainSalesSeries == 'FFCon/Exp/MOR/15715/2021-22' &&
            cr_item.uploadCreditDebit != '' &&
            cr_item.approvalStatus == '1' &&
            cr_item.creditDebitNoteType == '2'
          ) ? _c('b-badge', {
            staticClass: "p-1",
            attrs: {
              "variant": "warning",
              "size": "sm"
            },
            on: {
              "click": function($event) {
                _vm.PrintNote(
                  row15.item.mainSalesSeries,
                  'Approved-DEBIT -2022-02-03 11:37:17.pdf'
                )
              }
            }
          }, [(cr_item.creditDebitNoteType == '1') ? _c('span', [_vm._v(_vm._s(cr_item.noteSeries) + "\n                  ")]) : _c('b', [_vm._v(_vm._s(cr_item.noteSeries))]), _c('br')]) : _vm._e(), _c('br'), _vm._v(" "), (cr_item.creditDebitNoteType) ? _c('b-badge', {
            staticClass: "p-2",
            attrs: {
              "variant": "success"
            }
          }, [_c('b', [_vm._v(_vm._s(cr_item.creditDebitNoteType == "1" ? "Credit" : "Debit") + "\n                    Generated on " + _vm._s(cr_item.creditDebitTime))])]) : _vm._e()], 1)
        }), _vm._v(" "), (row15.item.isConsolidation == '1') ? _c('b-badge', {
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v("Consolidation")]) : _vm._e(), _vm._v(" "), (
          (row15.item.finalBillingCompleted == '1') ||
          (row15.item.billingType == 'Overseas Billing' &&
            row15.item.closedOverseasStatus == 'Overseas Closed')
        ) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed")]) : (row15.item.finalBillingCompleted == '4') ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed - Agent Expense Pending")]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Billing In-complete")]), _vm._v(" "), _c('br'), _vm._v(" "), (
          ((((row15.item.finalBillingCompleted != '1' || row15.item.finalBillingCompleted != '4') &&
              row15.item.billingType != 'Overseas Billing') ||
            ((row15.item.finalBillingCompleted == '1' || row15.item.finalBillingCompleted == '4') &&
              row15.item.billingType == 'Overseas Billing' &&
              row15.item.closedOverseasStatus != 'Overseas Closed')) && row15.item.totalExpCount <= 0 && row15.item.FF_Job_Exist_Flag == 1 && row15.item.agent_handling_expense == 'Yes' && row15.item.transportType == 'Export' && row15.item.nature_of_expense !== 'AGENT INVOICE') && _vm.$route.path !== '/viewBillingDetails/viewClosedAgentExpensePending'
        ) ? _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.validateBilling(row15.item.allModuleId, row15.item.jobType)
            }
          }
        }, [_vm._v("Closed. Agent Expense Pending ")]) : _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.validateBilling(row15.item.allModuleId, row15.item.jobType)
            }
          }
        }, [_vm._v("Close Billing")]), _vm._v(" "), (!row15.item.fk_loss_job_user_id && _vm.$route.path == '/viewBillingDetails/viewBillingDetails') ? _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.validateKnownLossJobModal(row15.item.allModuleId, row15.item.jobType, row15.item)
            }
          }
        }, [_vm._v("Known Loss Job")]) : _vm._e(), _vm._v(" "), (row15.item.fk_loss_job_user_id) ? _c('span', [_vm._v("Loss Job Remark:" + _vm._s(row15.item.known_loss_job_remark)), _c('br'), _vm._v("User Name:" + _vm._s(row15.item.loss_job_user)), _c('br'), _vm._v("Loss Job Date:" + _vm._s(row15.item.known_loss_job_date)), _c('br')]) : _vm._e(), _vm._v(" "), (row15.item.assignmentCloseReason) ? _c('span', {
          staticStyle: {
            "color": "green"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.wordWrap(row15.item.assignmentCloseReason, 12))
          }
        }) : _vm._e(), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row15.item.allModuleId
          }
        })]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-close-conf",
    attrs: {
      "id": "modal-close-conf",
      "title": "Submit Your Reason",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), (_vm.incompleteJobBill) ? _c('h4', {
    staticClass: "error"
  }, [_c('small', [_vm._v("Invoice Not added for ")]), _vm._v(" " + _vm._s(_vm.incompleteJobBill) + "\n      "), _c('small', [_vm._v(" Please Kindly Check..!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Reason for closing assignment billing",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.closingReason),
      callback: function($$v) {
        _vm.closingReason = $$v
      },
      expression: "closingReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.closingReason ? false : true,
      "variant": "success"
    },
    on: {
      "click": _vm.closeBillOk
    }
  }, [_vm._v("\n      Confirm & Close Billing")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeModalConfirm
    }
  }, [_vm._v("\n      Cancel")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "KnownLossJobModal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "title": "Known Loss Job Request",
      "size": "xs",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.closeKnownLossJobModal
    }
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "remark"
    }
  }, [_vm._v("Remark : *")]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "rows": "5",
      "id": "remark",
      "placeholder": "Pls Enter Remark",
      "type": "text"
    },
    model: {
      value: (_vm.knownLossJobItem.remark),
      callback: function($$v) {
        _vm.$set(_vm.knownLossJobItem, "remark", $$v)
      },
      expression: "knownLossJobItem.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-end"
  }, [_c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.knownLossJobItem.remark ? false : true,
      "variant": "primary"
    },
    on: {
      "click": _vm.validateKnownLossJob
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.closeKnownLossJobModal
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopApprove",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopReject",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDelete",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopTally",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.closeBillOk
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopClose1",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.closeBillOk
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopClose",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.closeconsolidationTXTOk
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8df1d38","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/viewBillingDetails.vue
// module id = 2858
// module chunks = 0